import { FormatEditor } from "@/components/FormatEditor";

const PLACEHOLDERS = ["company_name", "date", "partner_name", "firm_name", "partner_type", "pan", "gst", "address", "city", "pincode", "email", "phone"];

export default function AgreementFormat() {
  return (
    <FormatEditor
      title="Agreement Format"
      desc="Edit the partner agreement template (HTML with placeholders). Used when generating a partner's agreement PDF."
      endpoint="/settings/agreement-format"
      placeholders={PLACEHOLDERS}
      testId="agreement-format-page"
    />
  );
}
